<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [callbackFunction]="chartCallback"
  [style.height.px]="extraSettings.chartHeight"
  style="width: 100%; display: block;">
</highcharts-chart>
